//@ts-check
import { useCallback } from "react";
import Collapse from "../collapse";
import { Title } from "../components/title";
import { Card, ContentCard, GridLayer } from "./styles";

/**
 * @param {{ handleCollapse: (id: string) => void,
 *  collapses: Object<string, boolean>,
 *  rdmData: import("..").RdmData | null,
 *  options: { label: string, onClick: () => void, show: boolean }[],
 *  userPermissions: {
 *    canEdit: boolean,
 *    canDelete: boolean,
 *    canAdd: boolean
 * },
 * }} props
 * @return {JSX.Element}
 */
export function RdmCard({
  handleCollapse,
  collapses,
  rdmData,
  options,
  userPermissions,
}) {
  const visibleOptions = options.filter((o) => o.show !== false);

  const getPercentPositives = useCallback(() => {
    if (rdmData) {
      const total = rdmData?.positives + rdmData?.negatives;
      return ((rdmData.positives / total) * 100).toFixed(2);
    }
    return 0;
  }, [rdmData]);

  return (
    <Card id="rdm-card">
      <ContentCard>
        <Title
          handleCollapse={() => handleCollapse("rdm-card")}
          collapses={collapses["rdm-card"]}
          title="Dados Gerais do RDM"
          options={visibleOptions}
          userPermissions={userPermissions}
        />
        <Collapse isOpened={collapses["rdm-card"]}>
          <GridLayer columns={5}>
            <div className="column-item">
              <span className="column-title">Data de criação</span>
              <span className="column-content">{rdmData?.createdAt}</span>
            </div>
            <div className="column-item">
              <span className="column-title">Última atualização</span>
              <span className="column-content">{rdmData?.updatedAt}</span>
            </div>
            <div className="column-item">
              <span className="column-title">(%) Efetividade</span>
              <span className="column-content percents">
                {getPercentPositives()} %
              </span>
            </div>
            <div className="column-item">
              <span className="column-title">Positivos</span>
              <span className="column-content positive">
                {rdmData?.positives}
              </span>
            </div>
            <div className="column-item">
              <span className="column-title">Negativos</span>
              <span className="column-content negative">
                {rdmData?.negatives}
              </span>
            </div>
            <div className="column-item rdm-description">
              <span className="column-title">Descrição</span>
              <p className="column-content">{rdmData?.description}</p>
            </div>
          </GridLayer>
        </Collapse>
      </ContentCard>
    </Card>
  );
}
